import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AppointmentRequest} from '@shared/models/appointment-request.model';
import {HealthCard, IdentityDocument, Phone} from '@shared/models/register.model';
import {Subscription} from 'rxjs';

@Component({
  selector: 'si-appo-appointment-request-identification',
  templateUrl: './appo-appointment-request-identification.component.html',
  styleUrls: ['./appo-appointment-request-identification.component.scss']
})
export class AppoAppointmentRequestIdentificationComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() model = new AppointmentRequest();
  @Input() form: NgForm;
  @Input() formId = 'appoAppointmentRequestIdentificationForm';
  @Input() passwordErrorText: string;
  @Input() validationErrorTextIdentityDocument: string;
  @Output() formChange = new EventEmitter<NgForm>();
  @Output() loginSuccessChange = new EventEmitter<any>();
  @Output() captchaRenderedChange = new EventEmitter<boolean>();
  @ViewChild('appoAppointmentRequestIdentificationForm') appoAppointmentRequestIdentificationForm: NgForm;
  formSubscription: Subscription;
  displayLoginDialog: boolean;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Init objects
    this.model.identityDocument ??= new IdentityDocument();
    this.model.phone ??= new Phone();
    this.model.healthCardDocument ??= new HealthCard();
  }

  ngAfterViewInit(): void {
    this.appoAppointmentRequestIdentificationForm.control.markAsDirty();
    this.changeDetectorRef.detectChanges();
    this.setFormSubscription();
  }

  setFormSubscription(): void {
    this.formSubscription = this.appoAppointmentRequestIdentificationForm.statusChanges.subscribe(() => {
      this.form = this.appoAppointmentRequestIdentificationForm;
      this.formChange.emit(this.appoAppointmentRequestIdentificationForm);
    });
  }

  onClickLogin(): void {
    this.displayLoginDialog = true;
  }

  onLoginSuccessChange(): void {
    this.loginSuccessChange.emit();
  }

  onChangeCaptchaRendered(captchaRendered: boolean): void {
    this.captchaRenderedChange.emit(captchaRendered);
  }

  ngOnDestroy(): void {
    this.captchaRenderedChange.emit(false);
    this.formSubscription.unsubscribe();
  }
}
